// convex/lib/config/domains/mcp.ts

import { validatorMcpToken } from "../../../companies/mcp";
import type { DomainGroup, TableScope } from "../types";

/**
 * MCP de empresa (docs/analisis-mcp-empresa.md): tokens para que agentes de
 * IA (Claude Code, Cursor, Codex...) lean y, en fases siguientes, configuren
 * la empresa con los permisos del usuario dueño del token. Por defecto solo
 * `company_admin` (los usuarios quedan en "none"); el modulo va solo en los
 * planes superiores (`includedModules`).
 */
export const mcpDomain: DomainGroup = {
  id: "mcp",
  name: "Agentes (MCP)",
  description: "Conexion de agentes de IA a la configuracion de la empresa",
  icon: "Bot",
  order: 26,
  status: "active",

  i18n: {
    namespace: "mcp",
    keys: {
      title: "mcp.title",
      description: "mcp.description",
    },
  },

  modules: [
    {
      id: "mcp",
      name: "Agentes (MCP)",
      description: "Tokens para conectar agentes de IA (Claude Code, Cursor, Codex) a la empresa",
      icon: "Bot",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings/agents"],
      navigation: {
        showInNav: true,
        contexts: ["settings"],
        navOrder: 10,
        status: "active",
      },
      i18n: {
        namespace: "mcp.mcp",
        keys: {
          title: "mcp.mcp.title",
          description: "mcp.mcp.description",
          longDescription: "mcp.mcp.longDescription",
          searchPlaceholder: "mcp.mcp.searchPlaceholder",
          emptyState: "mcp.mcp.emptyState",
          actions: {
            create: "mcp.mcp.actions.create",
            edit: "mcp.mcp.actions.edit",
            delete: "mcp.mcp.actions.delete",
            view: "mcp.mcp.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },
      tables: [
        {
          tableName: "mcp_tokens",
          schema: validatorMcpToken,
          scope: "company" as TableScope,
          relations: [],
          searchFields: ["name"],
          hasStatusIndex: false,
          customRules: [],
        },
      ],
      readOnlyTables: [],
    },
  ],
};
